import { I18n } from '@calendly/i18n';
import { useClose } from '@calendly/ui/components/dropdown';
import { OptionUI } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelectData } from './context';
const statusBadgeCss = "sa1729f";
const StatusBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(statusBadgeCss, props.className)} />;
});
const notFoundTextCss = "nyzafz9";
const NotFoundText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(notFoundTextCss, props.className)} />;
});
export const OptionsList = ({
  isLoading,
  onChangeProperty,
  notFoundText,
  children
}) => {
  const {
    options,
    onChange
  } = useSelectData();
  const closeDropdown = useClose();
  const handleClick = option => {
    onChange(onChangeProperty ? option[onChangeProperty] : option.id);
    closeDropdown();
  };
  if (options.length === 0 && !isLoading && (!children || children?.length === 0)) {
    return <NotFoundText role="option">{notFoundText}</NotFoundText>;
  }
  return <>
      {children}
      {options.map(option => <OptionUI role="option" key={option.id} onClick={() => handleClick(option)}>
          {option.name}
          {option.isNew ? <>
              {' '}
              <StatusBadge>{I18n.t('publisher.organization_settings.user_provisioning.groups.calendly_group.new_label')}</StatusBadge>
            </> : null}
        </OptionUI>)}
    </>;
};

require("./options-list.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./options-list.js");